import { useTheme } from 'styled-components';

export const useStorageDarkMode = (): boolean => {
  // for force refresh when change mode
  useTheme();

  return typeof window === 'undefined' ? false : window.localStorage?.getItem('preferMode') === 'dark';
};
